import dynamic from 'next/dynamic';
const EventListPage  = dynamic(() => import('./EventListPage'));

export default EventListPage;
